import { useState } from "react";

const useListFilters = () => {
    const [search, setSearch] = useState();
    const [loading, setLoading] = useState(true);
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });

    return {
        search,
        loading,
        tableParams,
        setSearch,
        setLoading,
        setTableParams,
    }
}

export default useListFilters